import { cva } from '@/styled-system/css';

export const chipGroupRecipe = cva({
  base: {
    display: 'flex',
    columnGap: 'tighter',
    flexWrap: 'wrap',
  },
  variants: {
    verticalSpacing: {
      default: {
        rowGap: 'default',
      },
      tighter: {
        rowGap: 'tighter',
      },
    },
  },
});
